define('home/templates/settingsBlockingAlertError',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"alert alert--error text-small text-center\">\n<span class=\"icon-warning icon-tiny icon__position -inline\"></span>\n"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Something went wrong while trying to unblock this user. Please check your internet connection and try again.",{"name":"gettext","hash":{},"data":data}))
    + "\n<button class=\"link-inverted spacing-left\" data-action=\"close-alert\">\n<span class=\"icon-cancel icon__position\"></span>\n</button>\n</div>\n";
},"useData":true})

});
